import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
    initInternalCategoryInfo,
    requestInternalCategoryStart,
    requestInternalCategorySuccess,
    requestInternalCategoryFail,

    postInternalCategoryStart,
    postInternalCategorySuccess,
    postInternalCategoryFail,

    patchInternalCategoryStart,
    patchInternalCategorySuccess,

    deleteInternalCategoryStart,
    deleteInternalCategorySuccess,
    deleteInternalCategoryFail,

    requestDetailInternalCategoryStart,
    requestDetailInternalCategorySuccess,
    requestDetailInternalCategoryFail,

    putInternalCategoryStart,
    putInternalCategorySuccess,
    putInternalCategoryFail,

    deleteMultipleInternalCategoryStart,
    deleteMultipleInternalCategorySuccess,
    deleteMultipleInternalCategoryFail,

    patchMultipleInternalCategoryStart,
    patchMultipleInternalCategorySuccess,
    patchMultipleInternalCategoryFail,

    putMultipleInternalCategoryStart,
    putMultipleInternalCategorySuccess,
    putMultipleInternalCategoryFail,
} from '../actions/internal-category';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET, method_PUT, method_PATCH, method_DELETE, method_MULTIPLE_DELETE, method_MULTIPLE_PATCH, method_MULTIPLE_PUT } = requestManagement;

import CONFIG from '@root/config/config.next';

const url = CONFIG.backendEndpoint;

export function* requestInternalCategory({ payload }) {

    /*console.log('[sages] requestInternalCategory : ', payload);*/

    const apiURL = `${url}/backend/v1/category`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
            params: {
                "pagination[page]": payload.page === 0 ? 1 : payload.page,
                "pagination[limit]": payload.limit,
                "sort[field]": payload.field,
                "sort[order]": payload.order,
                "filter[status]": payload.status,
                "filter[q]": payload.q,
                "filter[parent]": payload.parent,
            }
        });

        /*console.log("[API] GET : ", data);*/

        yield put(requestInternalCategorySuccess(data));

    } catch (error) {
        yield put(requestInternalCategoryFail(error));
    }

    //====================================================================================================================
}

export function* postInternalCategory({ payload }) {
    /*console.log('[sages] postInternalCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category`;

    //====================================================================================================================

    try {
        const data = yield method_POST(
            {
                url: apiURL,
                data: payload.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(postInternalCategorySuccess(data));

    } catch (error) {
        yield put(postInternalCategoryFail(error));
    }

    //====================================================================================================================
}

export function* patchInternalCategory({ payload }) {
    /*console.log('[sages] patchInternalCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category/${payload?.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_PATCH(
            {
                url: apiURL,
                data: payload?.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(patchInternalCategorySuccess(data));

    } catch (error) {
        // yield put(patchInternalCategoryFail(error));
    }

    //====================================================================================================================
}

export function* deleteInternalCategory({ payload }) {
    /*console.log('[sages] deleteInternalCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category/${payload?.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_DELETE(
            {
                url: apiURL,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(deleteInternalCategorySuccess(data));

    } catch (error) {
        yield put(deleteInternalCategoryFail(error));
    }

    //====================================================================================================================
}

export function* requestDetailInternalCategory({ payload }) {

    /*console.log('[sages] requestDetailInternalCategory : ', payload);*/

    const apiURL = `${url}/backend/v1/category/${payload.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
        });

        /*console.log("[API] GET : ", data);*/

        yield put(requestDetailInternalCategorySuccess(data));

    } catch (error) {
        yield put(requestDetailInternalCategoryFail(error));
    }

    //====================================================================================================================
}

export function* putInternalCategory({ payload }) {
    /*console.log('[sages] putInternalCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category/${payload.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_PUT(
            {
                url: apiURL,
                data: payload.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(putInternalCategorySuccess(data));

    } catch (error) {
        yield put(putInternalCategoryFail(error));
    }

    //====================================================================================================================
}

export function* deleteMultipleInternalCategory({ payload }) {
    /*console.log('[sages] deleteMultipleInternalCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_DELETE(
            {
                url: apiURL,
                array: payload?.array
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(deleteMultipleInternalCategorySuccess(data));

    } catch (error) {
        yield put(deleteMultipleInternalCategoryFail(error));
    }

    //====================================================================================================================
}

export function* patchMultipleInternalCategory({ payload }) {
    /*console.log('[sages] patchMultipleInternalCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_PATCH(
            {
                url: apiURL,
                array: payload?.array,
                data: payload?.data,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(patchMultipleInternalCategorySuccess(data));

    } catch (error) {
        yield put(patchMultipleInternalCategoryFail(error));
    }

    //====================================================================================================================
}

export function* putMultipleInternalCategory({ payload }) {
    /*console.log('[sages] putMultipleInternalCategory : ', payload);*/
    const apiURL = `${url}/backend/v1/category`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_PUT(
            {
                url: apiURL,
                array: payload?.array,
                data: payload?.data,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(putMultipleInternalCategorySuccess(data));

    } catch (error) {
        yield put(putMultipleInternalCategoryFail(error));
    }

    //====================================================================================================================
}

export function* watchInternalCategory() {

    /*console.log('[sages] watchInternalCategory : ✅');*/

    yield all([
        takeLatest(requestInternalCategoryStart, requestInternalCategory),
        takeLatest(postInternalCategoryStart, postInternalCategory),
        takeLatest(patchInternalCategoryStart, patchInternalCategory),
        takeLatest(deleteInternalCategoryStart, deleteInternalCategory),
        takeLatest(requestDetailInternalCategoryStart, requestDetailInternalCategory),
        takeLatest(putInternalCategoryStart, putInternalCategory),
        takeLatest(deleteMultipleInternalCategoryStart, deleteMultipleInternalCategory),
        takeLatest(patchMultipleInternalCategoryStart, patchMultipleInternalCategory),
        takeLatest(putMultipleInternalCategoryStart, putMultipleInternalCategory),
    ])
}



